import { Route } from '@angular/router';
import { NotFoundComponent } from '@src/app/main-layout/errors/not-found/not-found.component';
import { HomeComponent } from '@src/app/main-layout/dashboard/home.component';
import { LoginComponent } from '@src/app/main-layout/login/login.component';
import { RegisterComponent } from '@src/app/main-layout/register/register.component';
import { AuthGuard } from '@src/app/_guards/auth.guard';

export const routes: Route[] = [
    {
        path: '',
        component: HomeComponent,
        data: { title: 'Hlavní nástěnka' },
        canActivate: [AuthGuard],
    },
    {
        path: 'users',
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'import',
        loadChildren: () => import('./features/import/import.module').then(m => m.ImportModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'report',
        loadChildren: () => import('./features/report/report.module').then(m => m.ReportModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'export',
        loadChildren: () => import('./features/export/export.module').then(m => m.ExportModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'compare',
        loadChildren: () => import('./features/compare/compare.module').then(m => m.CompareModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'mailer',
        loadChildren: () => import('./mailer/mailer.module').then(m => m.MailerModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'login',
        component: LoginComponent,
        data: { title: 'Online Office Solutions', value: 'login' },
    },
    {
        path: 'register',
        component: RegisterComponent,
        data: { value: 'register' },
    },

    { path: '**', component: NotFoundComponent, data: { value: 'notfound' } },
];
